import React from 'react';
import { Layout, Row, Button } from 'antd';
import { Switch, Route, Redirect, Link, useRouteMatch } from 'react-router-dom';
import { Login, Services, Faq } from 'pages';
import logo from 'assets/img/logo.png';
import styles from './Public.module.scss';
import EmployeeSignIn from './azure-ad-pages/EmployeeSignIn';
import SignIn from './azure-ad-pages/SignIn';
import { checkCookie, setCookie } from 'common/helpers';
import WellsFargoSignIn from './azure-ad-pages/WellsFargoSignIn';

const { Header, Footer, Content } = Layout;
const ButtonGroup = Button.Group;

const Public: React.FC = () => {
  const { path } = useRouteMatch();

  document.addEventListener('DOMContentLoaded', function () {
    //dom is fully loaded, but maybe waiting on images & css files
    checkCookie();
  });

  return (
    <Layout className="min-vh-100">
      <Header className={styles.header}>
        <Row type="flex" justify="space-between" align="middle">
          <div>
            <img src={logo} alt="" />
          </div>
          <ButtonGroup size="small">
            <Button type="link" size="small">
              <Link to={`${path}/`}>Home</Link>
            </Button>
            <Button
              type="link"
              href="http://www.RedVision.com"
              target="_blank"
              size="small"
            >
              Corporate
            </Button>
            <Button type="link" size="small">
              <Link to={`${path}/services`}>Services</Link>
            </Button>
            <Button
              type="link"
              href="mailto:All.NY.Customer.Service@DataTraceTitle.com"
              size="small"
            >
              Contact
            </Button>
            <Button type="link" size="small">
              <Link to={`${path}/login`}>Sign in</Link>
            </Button>
          </ButtonGroup>
        </Row>
      </Header>
      <Content>
        <Switch>
          <Redirect from={`${path}/`} to={`${path}/login`} exact={true} />
          <Route path={`${path}/login`} component={Login} />
          <Route path={`${path}/services`} component={Services} />
          <Route path={`${path}/faq`} component={Faq} />
          <Route path={`${path}/employee-signin`} component={EmployeeSignIn} />
          <Route path={`${path}/signin`} component={SignIn} />
          <Route
            path={`${path}/wells-fargo-signin`}
            component={WellsFargoSignIn}
          />
        </Switch>
      </Content>
      <Footer style={{ textAlign: 'center' }}>
        Copyright © 2007-{new Date().getFullYear()} DataTrace Information
        Services, LLC. All rights reserved.&nbsp;
        <a
          href="https://www.firstam.com/privacy-policy/#type-of-information"
          target="_blank"
        >
          Privacy Policy
        </a>
      </Footer>
      <div
        className={styles.ccpanotice}
        id="ccpa-notice"
        style={{ display: 'block' }}
      >
        <p>
          <strong>PRIVACY NOTICE</strong>
        </p>
        <p>
          This website uses cookies and similar technologies to manage your
          sessions, manage content, and improve your website experience. To
          learn more about these technologies, your options, and about other
          categories of personal information we collect through this website and
          how we may use it, please see our{' '}
          <a
            href="https://www.firstam.com/privacy-policy/#type-of-information"
            target="_blank"
          >
            privacy policy
          </a>
          . This notice is effective for your use of this website for the next
          14 days.
        </p>
        <button
          className="ant-btn ant-btn-primary"
          onClick={() => setCookie('priv3', 'yes')}
        >
          GOT IT
        </button>
        <br></br>
      </div>
      {/* <button className="ant-btn ant-btn-primary" onClick={() =>checkCookie()} >CHECK IT</button><br></br> */}
    </Layout>
  );
};

export default Public;
